import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Tooltip from 'flarum/common/components/Tooltip';
import Icon from 'flarum/common/components/Icon';
import extractText from 'flarum/common/utils/extractText';
import PollImage from './Poll/PollImage';
import PollOptions from './Poll/PollOptions';
import PollState from '../states/PollState';
import PollSubmitButton from './Poll/PollSubmitButton';
import { slug } from 'flarum/common/utils/string';
export default class PostPoll extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.state = new PollState(this.attrs.poll, this.attrs.post);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.preventClose = this.preventClose.bind(this);
    window.addEventListener('beforeunload', this.preventClose);
  }
  onremove(vnode) {
    super.onremove(vnode);
    window.removeEventListener('beforeunload', this.preventClose);
  }
  view() {
    const poll = this.attrs.poll;
    const state = this.state;
    const questionSlug = slug(poll.question());
    const infoItems = this.infoItems(state.getMaxVotes());
    return m("div", {
      className: "Post-poll",
      "data-id": poll.id()
    }, m("div", {
      className: "PollHeading"
    }, m("div", {
      className: "PollHeading-title-container"
    }, m("h3", {
      className: "PollHeading-title"
    }, poll.question()), poll.subtitle() && m("p", {
      className: "helpText PollHeading-subtitle"
    }, poll.subtitle())), m("div", {
      className: "PollHeading-actions"
    }, this.actionItems().toArray())), !!poll.imageUrl() && m(PollImage, {
      poll: poll
    }), m("div", null, m("fieldset", {
      className: "PollOptions"
    }, m("legend", {
      className: "sr-only"
    }, poll.question()), m(PollOptions, {
      name: questionSlug,
      options: poll.options(),
      state: state
    })), m("div", {
      className: "Poll-sticky"
    }, !infoItems.isEmpty() && m("div", {
      className: "helpText PollInfoText"
    }, infoItems.toArray()), state.showButton() && m(PollSubmitButton, {
      state: state
    }))));
  }
  actionItems() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    const state = this.state;
    if (poll.canSeeVoters()) {
      items.add('voters', m(Tooltip, {
        text: app.translator.trans('fof-polls.forum.public_poll')
      }, m(Button, {
        className: "Button PollHeading-voters",
        onclick: state.showVoters,
        icon: "fas fa-poll"
      })));
    }
    if (poll.canEdit()) {
      items.add('edit', m(Tooltip, {
        text: app.translator.trans('fof-polls.forum.moderation.edit')
      }, m(Button, {
        className: "Button PollHeading-edit",
        onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/EditPollModal', webpackMode: 'lazy-once' */ './EditPollModal'), {
          poll
        }),
        icon: "fas fa-pen"
      })));
    }
    if (poll.canDelete()) {
      items.add('delete', m(Tooltip, {
        text: app.translator.trans('fof-polls.forum.moderation.delete')
      }, m(Button, {
        className: "Button PollHeading-delete",
        onclick: this.deletePoll.bind(this),
        icon: "fas fa-trash"
      })));
    }
    return items;
  }
  infoItems(maxVotes) {
    const items = new ItemList();
    const poll = this.attrs.poll;
    if (app.session.user && !poll.canVote() && !poll.hasEnded()) {
      items.add('no-permission', m("span", null, m(Icon, {
        name: "fas fa-times-circle",
        className: "fa-fw"
      }), app.translator.trans('fof-polls.forum.no_permission')));
    }
    if (poll.endDate()) {
      items.add('end-date', m("span", null, m(Icon, {
        name: "fas fa-clock",
        className: "fa-fw"
      }), poll.hasEnded() ? app.translator.trans('fof-polls.forum.poll_ended') : app.translator.trans('fof-polls.forum.days_remaining', {
        time: dayjs(poll.endDate()).fromNow()
      })));
    }
    if (poll.canVote()) {
      items.add('max-votes', m("span", null, m(Icon, {
        name: "fas fa-poll",
        className: "fa-fw"
      }), app.translator.trans('fof-polls.forum.max_votes_allowed', {
        max: maxVotes
      })));
      if (!poll.canChangeVote()) {
        items.add('cannot-change-vote', m("span", null, m(Icon, {
          name: "fas fa-".concat(this.state.hasVoted() ? 'times' : 'exclamation', "-circle"),
          className: "fa-fw"
        }), app.translator.trans('fof-polls.forum.poll.cannot_change_vote')));
      }
    }
    return items;
  }
  deletePoll() {
    if (confirm(extractText(app.translator.trans('fof-polls.forum.moderation.delete_confirm')))) {
      this.attrs.poll.delete().then(() => {
        m.redraw.sync();
      });
    }
  }
  preventClose(e) {
    if (this.state.hasSelectedOptions()) {
      e.preventDefault();
      return true;
    }
    return undefined;
  }
}
flarum.reg.add('fof-polls', 'forum/components/PostPoll', PostPoll);flarum.reg.addChunkModule('206', '9614', 'fof-polls', 'forum/components/EditPollModal');